import React, { useRef, useEffect, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';
import {FrenchTypes} from '../../../../../../../../constants/utils/connectionTypes';
import ServiceData from '../../../../../../../../constants/models/serviceData';

import { ModalEducationInstitutionSection } from "./educationInstitutionSection";

export const FormEducationInstitution = ({ educationInstitutions, isLoading, userId, relocationDeclaration, setEditMode }) => {
	const [educationInstitutionList, setEducationInstitutionList] = useState([...educationInstitutions]);
	useEffect(() => {
		setEducationInstitutionList([...educationInstitutions]);
	}, [educationInstitutions]);

	function removeFromList(index) {
		setEducationInstitutionList(educationInstitutionList.filter((a) => a !== educationInstitutionList[index]));
	}
	return (
		<div className="card mx-sm mt-xs rounded">
			<div className="card-body scroll-default py-0">
				<article className="card" id="educationInstitution">
					<h3 className="sr-only visually-hidden">Étudiant(e)</h3>
					{educationInstitutionList.map((educationInstitution, index) => {
						return <ModalEducationInstitutionSection educationInstitution={educationInstitution} initCollapsedState={false} index={index} isLoading={isLoading} key={index} removeFromList={removeFromList} relocationDeclaration={relocationDeclaration} />;
					})}
					<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center pt-4 pb-1">
						<h4 className="sr-only visually-hidden">Ajouter un autre ÉTABLISSEMENT</h4>
						<button
							type="button"
							className="btn btn-icon btn-alert-info mx-auto py-2"
							onClick={(e) => {
								let serviceData = new ServiceData({
									userId: userId,
									serviceType: FrenchTypes.etudiant,
									serviceId: "etudiant" + educationInstitutionList.length,
									payload: {
										type: "Etudiant",
										name: "",
										address: {
											streetAddress: "",
											streetAddress2: "",
											postalCode: "",
											addressLocality: "",
											addressCountry: "FR",
										},
										level: "",
										label: "",
									},
								});
								setEducationInstitutionList([...educationInstitutionList, { ...serviceData, collapsed: true }]);
							}}>
							<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre ÉTABLISSEMENT
						</button>
					</footer>
				</article>
			</div>
			<div className="card-footer">
				<button
					type="button"
					className="btn btn-light mr-2"
					onClick={(e) => {
						e.preventDefault();
						setEducationInstitutionList([...educationInstitutions]);
						setEditMode(false);
					}}>
					Annuler
				</button>
				{/* <button
							type="button"
							className="btn btn-info"
							onClick={(e) => {
								e.preventDefault();
								educationInstitutionForm.current.classList.add("was-validated");
								setWasValidated(true);
							}}>
							Sauvegarder
						</button> */}
			</div>
		</div>
	);
};